// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"style-module_tableContainer__1Qxi1lClW16BQvFRj3CTmM","sectionHeader":"style-module_sectionHeader__FhVFKzvJJvREiwRtnD_QZ"};